import {init} from '../common/init.js';
import {contactForm} from '../common/contactForm.js';
import {dialogs} from '../common/dialogs.js';
import {binPage} from './binPageFunctions.js';
import {bins} from '../common/bins.js';
const Cookies = require('js-cookie');

//const Dotdotdot =require('dotdotdot-js');

require('../common/jquery.scrollManager.js');

(function ($) {

let  licenseAgreements = [];

	function initialize() {
	    if (typeof (reelPage) !== 'undefined' && reelPage) return true;
	    var dfd = new $.Deferred();
	    //var hashData = getHashData();
	    //var found = hashData.match(/c_(\w+)_/);
	    const params = new Proxy(new URLSearchParams(window.location.search), {
	        get: (searchParams, prop) => searchParams.get(prop),
	    });
	    if (params.clip) {
	        $.ajax({
	            data: {
	                action: 'getClippagenum',
	                clipHash: params.clip,
	                clipType: params.clipType ? params.clipType : 'Clip'
	            }
	        }).done(function (data) {
	            data = $.parseJSON(data);
	            $.when(binPage.initializeBinClips(data.pageNum)).done(function () {
	                dfd.resolve();
	            });
	        });
	    } else {
	        $.when(binPage.initializeBinClips(1)).done(function () {
	            dfd.resolve();
	        });
	    }
	    return dfd.promise();
	}

	

	function exportCSV() {
		dialogs.showConfirm({
            message: "<p>Include the scene-by-scene descriptive log?</p>" + 
            	"<p>(Warning: This could make for a very large CSV file, depending on the amount of footage included.)</p>",
            title: "Export CSV",
            successButtonText: "Include Log",
            cancelButtonText: "No Log",
            successHandler: function () {
            	location.href = bins.getCSVUrl(binPage.binInfo, true);
            },
            cancelHandler: function () {
                location.href = bins.getCSVUrl(binPage.binInfo, false);
            },
            extraButtons: {
            	"Cancel": function() {}
            },
            width: 450
        });
		
	}

    function copyBin(binId, destBinName) {

        $.ajax({
            data: {
                action: 'saveBincopy',
                binId: binId,
                shareBin: $('body').hasClass('shareBin'),
                order: $('body').hasClass('order'),
                binName: destBinName
            },
            dataType: 'json',
            success: function (obj) {

                bins.displayBinList(true, obj);
                var message =
                    "A copy of the bin has been created.  Would you like to open the new bin for editing or stay on the current bin?";

                dialogs.showConfirm({
                    message: message,
                    title: "Bin Saved",
                    successButtonText: "Stay on the current bin",
                    cancelButtonText: "Open new bin",
                    cancelHandler: function () {
                        location.href = bins.getBinUrl(obj.bins['bin' + obj.newBinId]);
                    },
                   
                    width: 450
                });
            }
        });
    }

    window.handlePageState = function (state) {
    	$("#mainArea").waitingBox();
		return $.when(initialize()).always(function () {
			$("#mainArea").trigger('stopWaiting');
		});
	};


	window.initPage = function () {

		//startRelativeDateTimeout(false);
		binPage.binInfo = $("#mainArea").data('bin');
		licenseAgreements = $("#mainArea").data('agreements');
		binPage.binContainer = $('#binContents');

		$('body').append($("<div/>").attr('id', 'tapeInfo').hide());

		$(".selectNone").on('click', function () {
			if ($(this).hasClass('disabled')) {
				return;
			}
			$(".chkClip:checked").prop('checked', false);
			$('.clipDetails.selected').removeClass('selected');
			$(".disableOnEmptySelection").addClass('disabled').prop('disabled', true);
			$("a.disableOnEmptySelection").attr('tabindex', '-1');

		});

		$(".selectAll").on('click', function () {
			if ($(this).hasClass('disabled')) {
				return;
			}

			$(".chkClip:not(:checked)").prop('checked', true);
			$('.clipDetails').addClass('selected');
			$(".disableOnEmptySelection").removeClass('disabled').prop('disabled', false);
			$("a.disableOnEmptySelection").attr('tabindex', '0');
		});

		$(".addSelected").on('click', function (event) {
			if ($(this).hasClass('disabled')) {
				return;
			}
			var message = '',
				clips = [],
				numClips = $(".chkClip:checked").length,	
				addToBinId = $(".binSelect", $(this).parent()).val();

			addToBinId = addToBinId == -1 || !addToBinId ? null : addToBinId;
			$(".chkClip:checked").each(function () {
				let clipDetails = $(this).closest('.clipDetails');
				clips.push({
					id: clipDetails.data('id'),
					reelId: clipDetails.data('reelId'),
					specialty: clipDetails.hasClass('specialty'),
					clipType: clipDetails.data('clip').clipType
				});
			});
			$.when(bins.addClipsToBin({
				clips: clips
			}, addToBinId)).done(function (binObj) {
				//bins.addSelectedToBin(addToBinId, function (binObj) {
				if (addToBinId == binPage.displayBinId) {
					binPage.displayBinDetails(binObj.bin);
				} else {
					if (numClips == 1) {
						message = "Your clip has been added to the bin \"" + binObj.bin.title +
							"\".  Would you like to open that bin for editing or stay on the current bin?";
					} else {
						message = "Your clips have been added to the bin \"" + binObj.bin.title +
							"\".  Would you like to open that bin for editing or stay on the current bin?";
					}
					dialogs.showConfirm({
						message: message,
						title: "Clip" + (numClips != 1 ? 's' : '') + " Saved",
						successButtonText: "Stay on the current bin",
						cancelButtonText: "Open \"" + binObj.bin.title + "\"",
						cancelHandler: function () {
							location.href = "bins/" + binObj.bin.hashId;
						},
						width: 450
					});
				}
			});
		});

		binPage.binContainer.on('click', 'li .titleBar', function (event) {
			let el = $(this),
				checkBox = el.find('.chkClip'),
				clipEl = el.closest('.clipDetails');

			if (checkBox.hasClass('disabled')) {
				return;
			}
			if ($(event.target).attr('id') != checkBox.attr('id'))
				checkBox.prop("checked", !checkBox.prop("checked"));

			clipEl.toggleClass('selected', checkBox.prop("checked"));

			if ($('.clipDetails.selected').length) {
				$(".tools .disableOnEmptySelection").removeClass('disabled').prop('disabled', false);
				$("a.disableOnEmptySelection").attr('tabindex', '0');
			} else {
				$(".tools .disableOnEmptySelection").addClass('disabled').prop('disabled', true);
				$("a.disableOnEmptySelection").attr('tabindex', '-1');
			}

		});

		binPage.binContainer.on('click', '.clipDetails .closeContainer', function (e) {
			var clipEl = $(this).closest('.clipDetails');
			e.stopPropagation();
			e.preventDefault();
			if ($(this).hasClass('disabled')) {

				return;
			}
			dialogs.showConfirm({
				message: "Are you sure you want to delete the clip \"" + clipEl.find('.tapeId').text() +
					"\"?",
				successHandler: function () {
					$.when(bins.deleteClip(clipEl.data('id'))).done(function(newBinInfo) {
                        binPage.binInfo = newBinInfo;
						binPage.displayBinDetails(binPage.binInfo);
						clipEl.remove();
					});
				},
				title: 'Confirm bin deletion'
			});
			return false;
		});

		$(".bigTools .mailBin").on('click', function () {
			if ($(this).hasClass('disabled')) {
				return;
			}
			contactForm.showMailBinDialog(binPage.binInfo, $('body').hasClass('shareBin') ? 'ShareBin' : 'Bin');
		});

		$(".saveBinCopy").on('click', function () {
			if ($(this).hasClass('disabled')) {
				return;
			}
			$("#txtNewBinName").val($("#binTitle").text() + ' (Copy)');

			bins.showAddBinDialog(function (newBinName) {
				copyBin(binPage.displayBinId, newBinName);
			});
		});

		$(".saveBinCSV").on('click', function () {
			if ($(this).hasClass('disabled')) {
				return;
			}
			exportCSV();
		});

		binPage.binContainer.on({

			click: function (event) {

				if ($(event.target).closest('.commentContainer').length ||
					$(event.target).closest('.titleBar').length) {
					return;
				}
				var li = $(this).closest('li');
				binPage.showClip(li);

			}
		}, "li");

		$(".contactResearcherBinPage").click(function () {
			if ($(this).hasClass('disabled')) {
				return;
			}
			contactForm.showContactResearcherBinDialog(binPage.binInfo);
		});

		$(".bigTools .deleteBin").click(function () {
			if ($(this).hasClass('disabled')) {
				return;
			}

			dialogs.showConfirm({
				message: "Are you sure you want to delete \"" + $('#binTitle').text() + "\"?",
				successHandler: function () {
					$.ajax({
						data: {
							action: 'deleteBin',
							binId: binPage.displayBinId
						},
						success: function (data) {
							var obj = $.parseJSON(data);
							if (Cookies.get('currentBinId') == binPage.displayBinId) {
								bins.setCurrentBin(obj.nextBinId);

							}
							location.replace("bins/" + obj.nextBinHash);
						}
					});
				},
				title: 'Confirm bin deletion'
			});
		});

		//orders Page
		$(".agreement.noFile").click(function () {
			if (!licenseAgreements) {
				return;
			}
			var agreement = licenseAgreements[$(this).attr('id')];
			dialogs.showAlert({
				title: agreement.title,
				message: agreement.content,
				width: 800,
				height: 800
			});
		});
		$(".cancelOrder").click(function () {
			dialogs.showConfirm({
				message: "Are you sure you want to cancel this order?",
				successHandler: function () {
					$.ajax({
						data: {
							action: 'cancelOrder',
							id: binPage.binInfo.id
						},
						success: function () {
							location.reload();
						}
					});
				},
				width: 400,
				successButtonText: 'Cancel Order',
				cancelButtonText: 'Don\'t Cancel Order',
				title: 'Cancel Order'
			});
		});

		$(".orderRequest").click(function () {
			if (!$(this).hasClass('disabled'))
				contactForm.showContactResearcherOrderDialog(binPage.binInfo.id);
		});

		$('#pay').click(function () {
			location.href = 'orderPayment/' + binPage.binInfo.id;
		});

		$('.wireTransfer').click(function() {
	        dialogs.showAlert({
	            title: 'Wire Transfer Information',
	            message: $('#wireTransferDialogContent').html()
	        })
	    });

		$(".downloadSelectedClips").click(function () {
			let button  = $(this),
				clipInfo ={},
				clipList;

			if (button.hasClass('disabled') || button.hasClass('activeDownload')) {
				return;
			}

			button.addClass('activeDownload');
			clipInfo.clips = {
				standard: $("#mainArea li.selected .clipDetailsContents.hasVideo:not(.specialtyCollection), .clipDetailsContents.specialAccess:not(.specialtyCollection)"),
				noVideo:  $("#mainArea li.selected .clipDetailsContents:not(.hasVideo):not(.specialAccess)"),
				specialty: $("#mainArea li.selected .clipDetailsContents.hasVideo.specialtyCollection")
			}

			if ($("#mainArea :checkbox:not(:checked)").length === 0) {
				clipInfo.objectId = binPage.displayBinId;
				if ($('body').hasClass('order')) {
					clipInfo.objectType = 'Order';
					clipInfo.singleObjectType = 'OrderClip';
				} else if ($('body').hasClass('shareBin')) {
					clipInfo.objectType = 'ShareBin';
					clipInfo.singleObjectType = 'ShareClip';
				} else {
					clipInfo.objectType = 'Bin';
					clipInfo.singleObjectType = 'Clip';
				}

			} else {
				let clipArray =[];
				clipInfo.clips.standard.each(function () {
					console.log('clip');
					clipArray.push($(this).data('id'));
				});

				clipInfo.clips.specialty.each(function () {
					clipArray.push($(this).data('id'));
				});

				clipInfo.objectId = clipArray.join(',');
				if ($('body').hasClass('order')) {
					clipInfo.objectType = 'OrderClip';
				} else if ($('body').hasClass('shareBin')) {
					clipInfo.objectType = 'ShareClip';
				} else {
					clipInfo.objectType = 'Clip';
				}
			}
			import('../common/videoOutput.js').then((module) => {
	            module.videoOutput.downloadMultipleClips(clipInfo);
	        });
		});

		if (typeof (binPage.binInfo) !== 'undefined') {
			binPage.displayBinDetails(binPage.binInfo);
		}
	};

	init.init();
	$(document).ready(function() {
		init.initPage();
	});



})(jQuery);
